import {
  computed,
  inject,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BannerGateway } from './banner.gateway';
import { DEFAULT_BANNER, IBanner } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { AppConfigService } from '../../app-config.service';

@Injectable({
  providedIn: 'root',
})
export class BannerStore {
  private readonly gateway: BannerGateway = new BannerGateway();
  private readonly configService: AppConfigService = inject(AppConfigService);
  bannerPath: Signal<string> = computed((): string => {
    return this.configService.get().general.cmsUrl + '/banner/image';
  });
  #bannerResource: ResourceRef<IApiResponse<IBanner> | undefined> = resource({
    loader: (): Promise<IApiResponse<IBanner>> => {
      return firstValueFrom(this.gateway.get());
    },
  });
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#bannerResource.isLoading()
  );
  readonly banner: Signal<IBanner> = computed(() => {
    if (this.#bannerResource.hasValue()) {
      const data: IBanner = this.#bannerResource.value()
        ?.data as unknown as IBanner;
      return data ?? DEFAULT_BANNER;
    }
    return DEFAULT_BANNER;
  });

  updateBanner(query: IBanner): void {
    this.#bannerResource.update((): IApiResponse<IBanner> => {
      return {
        data: query,
      };
    });
  }

  save(query: IBanner): void {
    firstValueFrom(this.gateway.save(query)).then(
      (result: IApiResponse<IBanner>): void => {
        if (result && result.data) {
          this.updateBanner(result.data);
        }
      }
    );
  }

  reload(): void {
    this.#bannerResource.reload();
  }
}
